import { useState, useEffect, useContext, useRef } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import './Home.module.css'
import { MyContext } from './context/UserProvider';
import { useNavigate } from 'react-router-dom';
import { SlArrowLeftCircle, SlArrowRightCircle } from "react-icons/sl";
import { FaCreditCard, FaTruck, FaBox, FaCouch, FaPalette } from 'react-icons/fa';
import { TbCirclePercentage } from "react-icons/tb";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import { useLocation } from 'react-router-dom';
import BackgroundImageWithLoader from '../layout/BackgroundImageWithLoader';
import Preloader from '../layout/Preloader';
import { AnimatePresence } from 'framer-motion';



export default function Home() {
  const { setProdutos, scrollY, setScrollY } = useContext(MyContext);
  const [windowDimensions, setWindowDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const scrollContainerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [anuncioAndProduto, setAnuncioAndProduto] = useState([]);
  const [banner, setBanner] = useState(null);
  const location = useLocation();
  const [hoveredImage, setHoveredImage] = useState(null);

  // calcula font size responsivo (mantém 40px quando viewportWidth === 1668)
  const [responsiveFontSize, setResponsiveFontSize] = useState(40);

  useEffect(() => {
    const baseWidth = 1668; // referência: 40px em 1668px
    const compute = () => {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      const size = Math.round(40 * (vw / baseWidth));
      setResponsiveFontSize(Math.max(12, size)); // mínimo 12px
    };
    compute();
    window.addEventListener('resize', compute);
    return () => window.removeEventListener('resize', compute);
  }, []);


  // ref para controlar o intervalo de troca automática das imagens
  const imageChangeTimerRef = useRef(null);

  const items = [
    // alterando
    {
      icon: (
        <FaTruck
          style={{
            cursor: 'pointer',
            color: '#fff',
            fontSize: windowDimensions.width < 500 ? '20px' : '30px',
            marginLeft: '5px',
            marginRight: '5px'
          }}
        />
      ),
      title: 'Entrega grátis!',
      description: 'São Paulo-Capital'
    },
    {
      icon: (
        <FaCouch
          style={{
            cursor: 'pointer',
            color: '#fff',
            fontSize: windowDimensions.width < 500 ? '20px' : '30px',
            marginLeft: '5px',
            marginRight: '5px'
          }}
        />
      ),
      title: ' Sofás sob medida',
      description: 'Personalize seu sofá'
    },
    {
      icon: (
        <FaPalette
          style={{
            cursor: 'pointer',
            color: '#fff',
            fontSize: windowDimensions.width < 500 ? '20px' : '25px',
            marginLeft: '5px',
            marginRight: '5px'
          }}
        />
      ),
      title: 'Variedade de cores',
      description: 'Em todos os produtos'
    },
    {
      icon: (
        <FaCreditCard
          style={{
            cursor: 'pointer',
            color: '#fff',
            fontSize: windowDimensions.width < 500 ? '20px' : '30px',
            marginLeft: '5px',
            marginRight: '5px'
          }}
        />
      ),
      title: 'Pague com cartão',
      description: 'em até 6x s/ juros'
    },
  ];

  const handleClick = (texto) => {
    const rota = texto.trim();
    navigate(`/${rota}`);
  };


  const navigate = useNavigate();

  // Função que faz a requisição para obter os dados dos sofás
  // getInfoSofas.js
  const getInfoSofas = async () => {
    const toSearch = {};

    const apiBase = process.env.REACT_APP_API_URL;


    try {
      const response = await fetch(`${apiBase}/api/getInfoSofas`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(toSearch),
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const json = await response.json();
      setProdutos(json);

    } catch (error) {
      console.error('Erro na requisição:', error);
    }
  };

  // getImagemProdutos.js


  const getAnunciosAndProdutosByCategoriaId = async (per_category = 6, signal) => {
    const toSearch = { per_category }; // envia per_category no body
    const apiBase = process.env.REACT_APP_API_URL;

    const response = await fetch(`${apiBase}/api/getAnunciosAndProdutosByCategoriaId`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toSearch),
      signal
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const json = await response.json();
    setAnuncioAndProduto(json)
    console.log("Dados de anúncios e produtos por categoria:", json);

    return json; // devolve array de categorias já agrupadas
  };

  const getBanner = async (signal) => {
    const apiBase = process.env.REACT_APP_API_URL;

    const response = await fetch(`${apiBase}/api/getBanner`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
      signal
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const json = await response.json();

    setBanner(json);

    console.log("Dados do banner:", json);

    return json;
  };




  function LinkToSocialMidia({ link }) {
    window.open(link, '_blank');

  }

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  // Funções para iniciar e resetar o timer automático de imagens
  const startImageTimer = () => {
    // limpa se já existir
    if (imageChangeTimerRef.current) clearInterval(imageChangeTimerRef.current);
    imageChangeTimerRef.current = setInterval(() => {
      // auto-scroll
      if (typeof autoScrollRight === 'function') {
        autoScrollRight();
      } else {
        // fallback chama scrollRight diretamente caso a função não exista ainda
        scrollRight();
      }
    }, 20000);
  };

  const resetImageTimer = () => {
    // apenas reinicia a contagem (limpa e inicia de novo)
    if (imageChangeTimerRef.current) clearInterval(imageChangeTimerRef.current);
    imageChangeTimerRef.current = setInterval(() => {
      if (typeof autoScrollRight === 'function') {
        autoScrollRight();
      } else {
        scrollRight();
      }
    }, 7000);
  };


  const [loading, setLoading] = useState(true);

  // Hook para buscar as informações assim que o componente for montado
  useEffect(() => {
    localStorage.setItem('categoria_id', null);

    const fetchData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          getAnunciosAndProdutosByCategoriaId(),
          getBanner(),
          getInfoSofas()
        ]);
        // Adiciona um pequeno delay artificial para evitar flash muito rápido se a API for instantânea, ou apenas para suavidade
        setTimeout(() => setLoading(false), 800);
      } catch (err) {
        console.error("Erro ao carregar dados da Home:", err);
        setLoading(false); // Garante que sai do loading mesmo com erro
      }
    };

    fetchData();


    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);



    // inicia o timer controlado pela ref
    startImageTimer();





    const handleResize = () => {
      setWindowDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };

    const interval = setInterval(nextSlide, 10000);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);

      clearInterval(interval);
      // limpar o timer guardado na ref
      if (imageChangeTimerRef.current) {
        clearInterval(imageChangeTimerRef.current);
        imageChangeTimerRef.current = null;
      }

      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Tamanho fixo das imagens, sem redimensionamento baseado na tela
  const imgWidth = '100%';  // Largura fixa para as imagens
  const imgHeight = '110vh'; // Altura fixa proporcional

  // Implementação da rolagem "automática" separada da função chamada pelos botões.
  // Isso nos permite evitar resetar o timer quando o auto-scroll ocorrer.
  const autoScrollRight = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const containerWidth = container.offsetWidth;
      const maxScrollLeft = container.scrollWidth - containerWidth;
      if (container.scrollLeft >= maxScrollLeft) {
        container.scrollLeft = 0;
      } else {
        container.scrollBy({ left: containerWidth, behavior: 'smooth' });
      }
    }
  };

  // Funções de scroll chamadas pelos botões (MANUAIS)
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const containerWidth = container.offsetWidth;
      const maxScrollLeft = container.scrollWidth - containerWidth;
      // Verifica se a rolagem já está na última imagem
      if (container.scrollLeft >= maxScrollLeft) {
        // Teleporta para a primeira imagem sem animação
        container.scrollLeft = 0;
      } else {
        container.scrollBy({ left: containerWidth, behavior: 'smooth' });
      }
    }
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const containerWidth = container.offsetWidth;
      // Verifica se já está na primeira imagem
      if (container.scrollLeft <= 0) {
        // Teleporta para a última imagem sem animação
        container.scrollLeft = container.scrollWidth - containerWidth;
      } else {
        container.scrollBy({ left: -containerWidth, behavior: 'smooth' });
      }
    }
  };

  return (
    <div
      translate="no"
      style={{
        backgroundColor: '#fff',
        margin: 0,
        overflowX: 'hidden',
        width: '100%'
      }}
    >




      <AnimatePresence>
        {loading && <Preloader key="preloader" />}
      </AnimatePresence>

      <Navbar />


      {/* Definição dos keyframes via tag style */}
      <style>{`
        @keyframes slideLeft {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(0);
          }
        }
        @keyframes slideRight {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(0);
          }
        }
           @keyframes propagandaSlideIn {
          from { transform: translateX(-40%); }
          to   { transform: translateX(1%);   }
        }
        @keyframes propagandaSlideOut {
          from { transform: translateX(10%); }
          to   { transform: translateX(0%);  }
        }

       @keyframes slideDownPropaganda {
          from { transform: translateY(-20px);opacity:0.5}
          to   { transform: translateY(0); opacity:1}
}
          @keyframes slideUpPropaganda {
          from {transform:translateY(100px);opacity:0}
          to {transform:translateY(0px);opacity:1}
          }
          @keyframes slideUpVantagens {
          from {transform:translateY(100px);opacity:0}
          to {transform:translateY(0);opacity:1}
          }
      `}</style>

      {/* Seção de apresentação com navegação de imagem principal */}
      <div style={{ position: 'relative', width: '100%' }}>
        {scrollY === 0 || windowDimensions.width <= 970 ? null : (
          <SlArrowLeftCircle
            size={20}
            onClick={() => {
              resetImageTimer();
              scrollLeft();
            }}
            style={{
              position: 'absolute',
              left: 10,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 3,
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              padding: '12px',
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            }}
          />
        )}

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div
            ref={scrollContainerRef}
            className="scroll-container"
            style={{
              overflowX: 'scroll',
              display: 'flex',
              scrollSnapType: 'x mandatory',
              WebkitOverflowScrolling: 'touch',
              width: '100%',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {anuncioAndProduto.map((cat, index) => (
              <div
                key={index}
                style={{
                  marginTop: scrollY === 0 ? '0px' : '60px',
                  width: '100%',
                  aspectRatio: '16 / 9',
                  flexShrink: 0,
                  position: 'relative',
                  scrollSnapAlign: 'start',
                  overflow: 'hidden',
                  cursor: 'pointer',


                }}
                onClick={() => {
                  handleClick(location.pathname.replace('/', ''));
                  localStorage.setItem('categoria_id', cat.categoria_id);
                  navigate(`/produtos/${cat.categoria_id}`);
                }}
              >
                <BackgroundImageWithLoader
                  src={cat?.anuncio?.anuncio_imagem_url}
                  style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    inset: 0,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    display: 'block',
                  }}
                />

                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background:
                      windowDimensions.width < 768
                        ? 'linear-gradient(90deg, rgba(0,0,0,0.44) 0%, rgba(0,0,0,0.20) 45%, rgba(0,0,0,0.04) 100%)'
                        : 'linear-gradient(90deg, rgba(0,0,0,0.48) 0%, rgba(0,0,0,0.22) 38%, rgba(0,0,0,0.08) 65%, rgba(0,0,0,0.02) 100%)',
                    zIndex: 1,
                  }}
                />

                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    zIndex: 2,
                    display: 'flex',
                    alignItems: windowDimensions.width < 768 ? 'center' : 'center',
                    padding:
                      windowDimensions.width < 480
                        ? '22px 16px'
                        : windowDimensions.width < 768
                          ? '30px 20px'
                          : windowDimensions.width < 1200
                            ? '38px 32px'
                            : '50px 46px',
                    opacity: scrollY > 0 ? 1 : 0,
                    transform: scrollY > 0 ? 'translateY(0px)' : 'translateY(18px)',
                    transition: 'opacity 0.55s ease, transform 0.55s ease',
                    pointerEvents: scrollY > 0 ? 'auto' : 'none',
                  }}
                >
                  <div
                    style={{
                      maxWidth:
                        windowDimensions.width < 480
                          ? '220px'
                          : windowDimensions.width < 768
                            ? '260px'
                            : windowDimensions.width < 1024
                              ? '360px'
                              : '620px',
                      color: '#fff',
                      transform:
                        windowDimensions.width < 768
                          ? 'translateY(0px)'
                          : 'translateY(-20px)',
                    }}
                  >
                    <div
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding:
                          windowDimensions.width < 768 ? '6px 12px' : '8px 16px',
                        borderRadius: '999px',
                        background: 'rgba(255,255,255,0.12)',
                        backdropFilter: 'blur(6px)',
                        WebkitBackdropFilter: 'blur(6px)',
                        border: '1px solid rgba(255,255,255,0.18)',
                        fontSize: windowDimensions.width < 768 ? '5px' : '11px',
                        letterSpacing: '0.22em',
                        textTransform: 'uppercase',
                        marginBottom: windowDimensions.width < 768 ? '10px' : '18px',
                        color: 'rgba(255,255,255,0.92)',
                      }}
                    >
                      Conforto • Durabilidade • Estilo
                    </div>

                    <h1
                      style={{
                        margin: 0,
                        fontFamily: "'Cormorant Garamond', serif",
                        fontWeight: 500,
                        lineHeight: 0.95,
                        letterSpacing: '-0.03em',
                        fontSize:
                          windowDimensions.width < 480
                            ? '16px'
                            : windowDimensions.width < 768
                              ? '32px'
                              : windowDimensions.width < 1024
                                ? '42px'
                                : windowDimensions.width < 1400
                                  ? '56px'
                                  : '72px',
                      }}
                    >
                      {cat?.anuncio?.anuncio_titulo || 'Design que permanece. Conforto que acolhe.'}
                    </h1>

                    <p
                      style={{
                        marginTop: windowDimensions.width < 768 ? '10px' : '18px',
                        marginBottom: 0,
                        maxWidth: '100%',
                        fontSize:
                          windowDimensions.width < 480
                            ? '9px'
                            : windowDimensions.width < 768
                              ? '12px'
                              : windowDimensions.width < 1024
                                ? '14px'
                                : '18px',
                        lineHeight: windowDimensions.width < 768 ? 1.45 : 1.65,
                        color: 'rgba(255,255,255,0.88)',
                      }}
                    >
                      {cat?.anuncio?.anuncio_subtitulo ||
                        (windowDimensions.width < 768
                          ? 'Conforto, presença e acabamento pensados para durar.'
                          : 'Sofás pensados nos detalhes para unir conforto, durabilidade e uma estética que continua fazendo sentido com o passar dos anos.')}
                    </p>

                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px',
                        marginTop: windowDimensions.width < 768 ? '14px' : '24px',
                      }}
                    >

                      {windowDimensions.width >= 768 && (
                        <button
                          style={{
                            border: 'none',
                            borderRadius: '999px',
                            background: '#fff',
                            color: '#1b1816',
                            padding: '13px 22px',
                            fontSize: '14px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleClick(location.pathname.replace('/', ''));
                            localStorage.setItem('categoria_id', cat.categoria_id);
                            navigate(`/produtos/${cat.categoria_id}`);
                          }}
                        >
                          Ver coleção
                        </button>
                      )}

                      {windowDimensions.width >= 768 && (
                        <button
                          style={{
                            border: '1px solid rgba(255,255,255,0.22)',
                            borderRadius: '999px',
                            background: 'rgba(255,255,255,0.10)',
                            color: '#fff',
                            padding: '13px 22px',
                            fontSize: '14px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            backdropFilter: 'blur(6px)',
                            WebkitBackdropFilter: 'blur(6px)',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleClick(location.pathname.replace('/', ''));
                            localStorage.setItem('categoria_id', cat.categoria_id);
                            navigate(`/produtos/${cat.categoria_id}`);
                          }}
                        >
                          Montar orçamento
                        </button>
                      )}
                    </div>
                  </div>
                </div>



                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: '16px',
                    zIndex: 3,
                    marginTop: 0,
                    marginRight: 5,
                    marginLeft: 5,
                    overflow: 'hidden',
                    display: 'inline-block',
                    animation: scrollY === 0 ? 'slideUpVantagens 3s ease forwards' : null
                  }}
                >
                  {windowDimensions.width > 970 ? (
                    <ul
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        listStyle: 'none'
                      }}
                    >
                      <li
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          marginLeft: '20px',
                          marginRight: '20px'
                        }}
                      >
                        <FaTruck
                          onClick={() =>
                            LinkToSocialMidia({ link: 'https://www.facebook.com/' })
                          }
                          style={{
                            cursor: 'pointer',
                            color: '#fff',
                            fontSize: '40px',
                            marginLeft: '10px',
                            marginRight: '10px'
                          }}
                        />
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          <p
                            style={{
                              margin: '0',
                              fontWeight: 'bold',
                              color: '#fff'
                            }}
                          >
                            Entrega gratis!
                          </p>
                          <p
                            style={{
                              margin: '0',
                              color: '#fff'
                            }}
                          >
                            São Paulo-Capital
                          </p>
                        </div>
                      </li>

                      <li
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          marginLeft: '20px',
                          marginRight: '20px'
                        }}
                      >
                        <FaCouch
                          onClick={() =>
                            LinkToSocialMidia({ link: 'https://www.facebook.com/' })
                          }
                          style={{
                            cursor: 'pointer',
                            color: '#fff',
                            fontSize: '45px',
                            marginLeft: '10px',
                            marginRight: '10px'
                          }}
                        />
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          <p
                            style={{
                              margin: '0',
                              fontWeight: 'bold',
                              color: '#fff'
                            }}
                          >
                            Sofás sob medida
                          </p>
                          <p
                            style={{
                              margin: '0',
                              color: '#fff'
                            }}
                          >
                            Personalize seu sofá
                          </p>
                        </div>
                      </li>

                      <li
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          marginLeft: '20px',
                          marginRight: '20px'
                        }}
                      >
                        <FaPalette
                          onClick={() =>
                            LinkToSocialMidia({
                              link: 'https://www.instagram.com/royal.sofas/'
                            })
                          }
                          style={{
                            cursor: 'pointer',
                            color: '#fff',
                            fontSize: '40px',
                            marginLeft: '10px',
                            marginRight: '10px'
                          }}
                        />
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          <p
                            style={{
                              margin: '0',
                              fontWeight: 'bold',
                              color: '#fff'
                            }}
                          >
                            Variedade de cores
                          </p>
                          <p
                            style={{
                              margin: '0',
                              color: '#fff'
                            }}
                          >
                            Em todos os produtos
                          </p>
                        </div>
                      </li>

                      <li
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          marginLeft: '20px',
                          marginRight: '20px'
                        }}
                      >
                        {/* bases*/}
                        <FaCreditCard
                          onClick={() =>
                            LinkToSocialMidia({ link: 'https://br.linkedin.com/' })
                          }
                          style={{
                            cursor: 'pointer',
                            color: '#fff',
                            fontSize: '40px',
                            marginLeft: '10px',
                            marginRight: '10px'
                          }}
                        />
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          <p
                            style={{
                              margin: '0',
                              fontWeight: 'bold',
                              color: '#fff'
                            }}
                          >
                            Parcelamos
                          </p>
                          <p
                            style={{
                              margin: '0',
                              color: '#fff'
                            }}
                          >
                            em até 6x s/ juros
                          </p>
                        </div>
                      </li>
                    </ul>
                  ) : (
                    <ul
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        listStyle: 'none',
                        marginLeft: '5px',
                        marginRight: '5px',
                        marginBottom: 0,
                        padding: '0',
                        transition: 'transform 0.5s ease-in-out'
                      }}
                    >
                      <li
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          flexShrink: 0
                        }}
                      >
                        {items[(currentIndex) % items.length].icon}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            marginLeft: '8px'
                          }}
                        >
                          <p
                            style={{
                              margin: '0',
                              fontWeight: 'bold',
                              color: '#fff',
                              fontSize: '9px',
                              lineHeight: '1.2'
                            }}
                          >
                            {items[(currentIndex) % items.length].title}
                          </p>
                          <p
                            style={{
                              margin: '0',
                              color: '#fff',
                              fontSize: '9px',
                              lineHeight: '1.2'
                            }}
                          >
                            {items[(currentIndex) % items.length].description}
                          </p>
                        </div>
                      </li>

                      <li
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          marginLeft: '20px',
                          marginRight: '20px',
                          flexShrink: 0
                        }}
                      >
                        {items[(currentIndex + 1) % items.length].icon}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            marginLeft: '8px'
                          }}
                        >
                          <p
                            style={{
                              margin: '0',
                              fontWeight: 'bold',
                              color: '#fff',
                              fontSize: '9px',
                              lineHeight: '1.2'
                            }}
                          >
                            {items[(currentIndex + 1) % items.length].title}
                          </p>
                          <p
                            style={{
                              margin: '0',
                              color: '#fff',
                              fontSize: '9px',
                              lineHeight: '1.2'
                            }}
                          >
                            {items[(currentIndex + 1) % items.length].description}
                          </p>
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {scrollY === 0 || windowDimensions.width <= 970 ? null : (
          <SlArrowRightCircle
            size={20}
            onClick={() => {
              resetImageTimer();
              scrollRight();
            }}
            style={{
              position: 'absolute',
              right: 10,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 3,
              color: '#fff',

              border: 'none',
              borderRadius: '50%',
              padding: '12px',
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            }}
          />
        )}
      </div>




      <div
        style={{
          marginTop: scrollY === 0 ? '40px' : '10px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          flexWrap: 'wrap',
          animation: scrollY === 0 ? 'slideUpVantagens 3s ease forwards' : null,
          overflow: 'hidden',
          margin: 0,
        }}
      >
        <div
          style={{
            width: '100%',
            marginTop: windowDimensions.width < 700 ? '10px' : '30px',
            marginBottom: '10px',
          }}
        >
          <style>
            {` 
                  @keyframes fadeUpSectionTitle { 
                    from { 
                      opacity: 0; 
                      transform: translateY(18px); 
                    } 
                    to { 
                      opacity: 1; 
                      transform: translateY(0); 
                    } 
                  } 
                `}
          </style>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: windowDimensions.width < 700 ? '10px' : '30px',
            }}
          >
            <h2
              style={{
                margin: '0 0 10px 0',
                textAlign: 'center',
                fontSize: windowDimensions.width < 700 ? '20px' : '30px',
                lineHeight: 1.1,
                color: '#111',
                fontFamily: '"Playfair Display", serif',
                fontWeight: 400,
                opacity: scrollY > (windowDimensions.width < 1662 ? 0.01 : 250) ? 1 : 0,
                transform: scrollY > (windowDimensions.width < 1662 ? 0.01 : 250)
                  ? 'translateY(0)'
                  : 'translateY(18px)',
                animation: scrollY > (windowDimensions.width < 1662 ? 0.01 : 250)
                  ? 'fadeUpSectionTitle 1.4s ease forwards'
                  : 'none',
                transition: 'opacity 0.9s ease, transform 1.4s ease'
              }}
            >
              Sua escolha começa aqui
            </h2>

            <p
              style={{
                margin: 0,
                textAlign: 'center',
                fontSize: windowDimensions.width < 700 ? '10px' : '14px',
                lineHeight: 1.6,
                color: '#6f6f6f',
                fontFamily: '"Helvetica Neue", Arial, sans-serif',
                fontWeight: 300,
                letterSpacing: '0.3px',
                maxWidth: '520px',
                padding: '0 20px',
                opacity: scrollY > (windowDimensions.width < 1662 ? 0.01 : 250) ? 1 : 0,
                transform: scrollY > (windowDimensions.width < 1662 ? 0.01 : 250)
                  ? 'translateY(0)'
                  : 'translateY(18px)',
                animation: scrollY > (windowDimensions.width < 1662 ? 0.01 : 250)
                  ? 'fadeUpSectionTitle 1.6s ease forwards'
                  : 'none',
                transition: 'opacity 1s ease, transform 1.5s ease'
              }}
            >
              Descubra modelos pensados para diferentes estilos de vida, com conforto, elegância e presença em cada detalhe.
            </p>
          </div>

          <div
            style={{
              display: windowDimensions.width < 700 ? 'flex' : 'grid',

              flexWrap: windowDimensions.width < 700 ? 'wrap' : undefined,

              justifyContent: 'center',

              gridTemplateColumns: windowDimensions.width < 700
                ? undefined
                : 'repeat(2, minmax(0, 500px))',

              columnGap: windowDimensions.width < 700
                ? undefined
                : '10px',

              rowGap: windowDimensions.width < 700
                ? undefined
                : '0px',

              width: windowDimensions.width < 700
                ? '100%'
                : 'calc(100% - 40px)',

              maxWidth: windowDimensions.width < 700
                ? 'none'
                : '1010px',

              margin: '0 auto',
            }}
          >
            {anuncioAndProduto.map((cat, index) => {
              const produtosDestaque = {
                1: 'royal 9',
                2: 'royal 17',
                3: 'royal 14',
                4: 'royal 6',
                5: 'royal 35',
              };

              const produtos = cat?.produtos || [];

              const nomeDesejado = produtosDestaque[cat?.categoria_id];

              const produto =
                produtos.find(p =>
                  (p?.nome || p?.produto_nome || '')
                    .toLowerCase()
                    .includes((nomeDesejado || '').toLowerCase())
                ) || produtos[0];

              if (!produto) return null;

              return (
                <div
                  key={cat?.categoria_id || index}
                  style={{
                    flex: windowDimensions.width < 700
                      ? '0 0 calc(45% - 10px)'
                      : 'none',

                    width: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',

                    display: 'flex',
                    flexDirection: 'column',

                    padding: windowDimensions.width < 700
                      ? '5px'
                      : '0px',

                    margin: windowDimensions.width < 700
                      ? '5px'
                      : '0px',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      aspectRatio: '4 / 3',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                    }}
                    onClick={() => {
                      localStorage.setItem(
                        'categoria_id',
                        Number(cat.categoria_id)
                      );

                      navigate(`/produtos/${cat.categoria_id}`);
                    }}
                  >
                    <img
                      src={
                        produto?.produto_imagem_url ||
                        produto?.imagem_url ||
                        produto?.imagem ||
                        ''
                      }
                      alt={cat?.categoria_nome || 'Categoria'}
                      style={{
                        width: '100%',
                        height: '100%',
                        display: 'block',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        cursor: 'pointer',
                      }}
                    />
                  </div>

                  <p
                    style={{
                      margin: '14px 0 8px 0',
                      textAlign: 'center',
                      fontSize: windowDimensions.width < 700 ? '10px' : '18px',
                      lineHeight: 1.2,
                      color: '#111',
                      fontFamily: '"Playfair Display", serif',
                      fontWeight: 400
                    }}
                  >
                    {cat?.categoria_nome || 'Categoria'}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {(() => {
          if (!anuncioAndProduto || anuncioAndProduto.length === 0) return null;

          const elements = [];
          const isMobileGlobal = windowDimensions?.width < 970;
          const MAX_PER_CATEGORY = isMobileGlobal ? 4 : 6;

          const formatBRL = (value) => {
            const numero = Number(value);

            if (Number.isNaN(numero)) return '';

            return numero.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            });
          };

          const produtosDestaque = {
            1: ['royal 9', 'royal 8', 'Royal 28'],
            2: ['royal 1', 'royal 13', 'royal 17'],
            3: ['royal 14', 'royal 3', 'royal 31'],
          };

          anuncioAndProduto.slice(0, 3).forEach((cat, catIndex) => {
            const catId = cat?.categoria_id ?? `cat-${catIndex}`;
            const adImage = cat?.anuncio?.anuncio_imagem_url ?? null;

            // =========================
            // ANÚNCIO DA CATEGORIA
            // =========================
            // =========================
            // ANÚNCIO / BANNER
            // =========================

            // PRIMEIRA CATEGORIA = RETRÁTEIS
            // usa o banner de acabamento no lugar do anúncio
            if (catIndex === 0 && banner?.imagem_url) {
              elements.push(
                <img
                  key={`banner-${banner.banner_id || 'acabamento'}`}
                  src={banner.imagem_url}
                  alt={banner.titulo || 'Acabamento Royal Sofás'}
                  loading="lazy"
                  style={{
                    display: 'block',
                    width: '100%',
                    height: 'auto',
                    maxWidth: 'none',
                    maxHeight: 'none',
                    margin: isMobileGlobal ? '10px 0 0' : 0,
                    padding: 0,
                    flex: '0 0 100%',
                  }}
                />
              );
            }

            // DEMAIS CATEGORIAS
            // continuam usando o anúncio normalmente
            else if (adImage) {
              elements.push(
                <BackgroundImageWithLoader
                  key={`ad-cat-${catId}`}
                  src={adImage}
                  style={{
                    flex: '0 0 100%',
                    width: '100%',
                    height: isMobileGlobal ? 400 : 1000,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center top',
                    backgroundColor: '#000',
                    display: 'block',
                    marginTop: isMobileGlobal ? '10px' : 0,
                    cursor: 'pointer',
                    position: 'relative',
                  }}
                  onClick={() => {
                    handleClick(location.pathname.replace('/', ''));
                    localStorage.setItem(
                      'categoria_id',
                      cat.categoria_id
                    );
                    navigate(
                      `/produtos/${cat.categoria_id}`
                    );
                  }}
                />
              );
            }

            // se ainda não tiver anúncio no banco
            else {
              elements.push(
                <div
                  key={`ad-cat-placeholder-${catId}`}
                  style={{
                    flex: '0 0 100%',
                    width: '100%',
                    height: isMobileGlobal ? 200 : 500,
                    backgroundColor: '#000',
                    display: 'block',
                    marginTop: isMobileGlobal ? '10px' : 0,
                  }}
                />
              );
            }

            // =========================
            // TÍTULO DA CATEGORIA
            // =========================

            elements.push(
              <div
                key={`title-${catId}`}
                style={{
                  flex: '0 0 100%',
                  textAlign: 'center',
                  marginTop: isMobileGlobal ? 24 : 40,
                  marginBottom: isMobileGlobal ? 16 : 24,
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    fontWeight: 400,
                    fontSize: isMobileGlobal ? '20px' : '30px',
                    lineHeight: 1.1,
                    color: '#111',
                    fontFamily: '"Playfair Display", serif',
                  }}
                >
                  descubra a seleção de {cat?.categoria_nome || 'Produtos'}
                </h2>
              </div>
            );

            // =========================
            // PRODUTOS
            // =========================

            const nomesDesejados =
              produtosDestaque[cat?.categoria_id] || [];

            const todosProdutos = cat?.produtos || [];

            let produtos = [];

            if (nomesDesejados.length) {
              const selecionados = nomesDesejados
                .map((nome) =>
                  todosProdutos.find(
                    (p) =>
                      (p?.produto_nome || p?.nome || '')
                        .toLowerCase()
                        .trim() ===
                      nome.toLowerCase().trim()
                  )
                )
                .filter(Boolean);

              const restantes = todosProdutos
                .filter((p) => !selecionados.includes(p))
                .sort((a, b) => {
                  const ordemA = a.produto_ordem ?? 999;
                  const ordemB = b.produto_ordem ?? 999;

                  if (ordemA !== ordemB) {
                    return ordemA - ordemB;
                  }

                  return (a.produto_id ?? 0) - (b.produto_id ?? 0);
                });

              produtos = [...selecionados, ...restantes].slice(
                0,
                MAX_PER_CATEGORY
              );
            } else {
              produtos = todosProdutos
                .sort((a, b) => {
                  const ordemA = a.produto_ordem ?? 999;
                  const ordemB = b.produto_ordem ?? 999;

                  if (ordemA !== ordemB) {
                    return ordemA - ordemB;
                  }

                  return (a.produto_id ?? 0) - (b.produto_id ?? 0);
                })
                .slice(0, MAX_PER_CATEGORY);
            }


            produtos.forEach((produto, pIndex) => {
              const isMobile = windowDimensions?.width < 970;

              const produtoImage =
                produto.produto_imagem_url ||
                produto.imagem_url ||
                produto.imagem ||
                '';

              const produtoImageUso =
                produto.produto_imagem_uso_url || produtoImage;

              const hoverKey = `hover_prod_${produto.produto_id}`;

              const currentImage =
                hoveredImage === hoverKey
                  ? produtoImageUso
                  : produtoImage;

              if (
                produtoImageUso &&
                produtoImageUso !== produtoImage
              ) {
                const imgPreload = new Image();
                imgPreload.src = produtoImageUso;
              }

              elements.push(
                <div
                  key={
                    produto.produto_id ??
                    `prod-${catId}-${pIndex}`
                  }
                  style={{
                    flex: isMobile
                      ? '0 0 calc(45% - 10px)'
                      : '0 0 calc(26% - 0px)',
                    display: 'flex',
                    flexDirection: 'column',
                    margin: 5,
                    minWidth: 0,
                    boxSizing: 'border-box',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      aspectRatio: '4 / 3',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      boxSizing: 'border-box',
                    }}
                    onClick={() => {
                      localStorage.setItem(
                        'produto_id',
                        Number(produto.produto_id)
                      );

                      localStorage.setItem(
                        'categoria_id',
                        Number(produto.categoria_id ?? catId)
                      );

                      navigate(
                        `/produto/${produto.produto_id}`
                      );
                    }}
                  >
                    <img
                      src={currentImage}
                      alt={produto.nome || 'Produto'}
                      style={{
                        width: '100%',
                        height: '100%',
                        display: 'block',
                        objectFit: 'contain',
                        objectPosition: 'center center',
                        cursor: 'pointer',
                        transition: 'transform 0.7s ease-in-out',
                      }}
                      onMouseEnter={() =>
                        setHoveredImage(hoverKey)
                      }
                      onMouseLeave={() =>
                        setHoveredImage(null)
                      }
                    />
                  </div>
                  <div
                    style={{
                      marginTop: isMobile
                        ? '12px'
                        : '14px',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <p
                      style={{
                        margin: '0 0 2px 9px',
                        textAlign: 'left',
                        fontSize: isMobile
                          ? '11px'
                          : '12px',
                        color: '#111',
                        fontFamily:
                          'Arial, Helvetica, sans-serif',
                      }}
                    >
                      {produto.produto_nome ||
                        produto.nome ||
                        'Produto'}
                    </p>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent:
                          'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <p
                        style={{
                          margin: '0 0 0 9px',
                          textAlign: 'left',
                          fontSize: isMobile
                            ? '12px'
                            : '13px',
                          color: '#7a7a7a',
                          fontFamily:
                            'Arial, Helvetica, sans-serif',
                        }}
                      >
                        {produto.preco_inicial != null
                          ? formatBRL(produto.preco_inicial)
                          : ''}
                      </p>

                      <p
                        style={{
                          margin: '0 10px 0 0',
                          textAlign: 'right',
                          fontSize: isMobile
                            ? '7px'
                            : '13px',
                          color: '#7a7a7a',
                          fontFamily:
                            'Arial, Helvetica, sans-serif',
                        }}
                      >
                        {produto.tamanho_inicial_cm != null
                          ? `${produto.tamanho_inicial_cm} cm`
                          : ''}
                      </p>
                    </div>
                  </div>
                </div>
              );

            });

            // =========================
            // BOTÃO DA CATEGORIA
            // =========================

            elements.push(
              <div
                key={`button-${catId}`}
                style={{
                  flex: '0 0 100%',
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: isMobileGlobal ? 20 : 30,
                  marginBottom: isMobileGlobal ? 20 : 40,
                }}
              >
                <button
                  onClick={() => {
                    handleClick(
                      location.pathname.replace('/', '')
                    );

                    localStorage.setItem(
                      'categoria_id',
                      cat.categoria_id
                    );

                    navigate(
                      `/produtos/${cat.categoria_id}`
                    );
                  }}
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #111',
                    borderRadius: '999px',
                    padding: isMobileGlobal
                      ? '12px 28px'
                      : '16px 40px',
                    fontSize: isMobileGlobal
                      ? '14px'
                      : '18px',
                    fontFamily:
                      '"Playfair Display", serif',
                    color: '#111',
                    cursor: 'pointer',
                  }}
                >
                  Descubra a Coleção
                </button>
              </div>
            );



          });

          return elements;
        })()}

      </div>

      <Footer />

    </div >
  );
}
